export default __webpack_public_path__ + "static/media/onlineDeposit.f4c380f0.svg";